import { Field } from 'formik';
import { twMerge } from 'tailwind-merge';

type FieldProps = {
  fieldClassName?: string;
  name: string;
  label: string;
  textArea?: boolean;
  type?: string;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
};

const FormField = ({ fieldClassName, name, label, textArea, type = 'text', inputMode }: FieldProps) => {
  const fieldTwClassName = 'border-1 border-solid border-gray-medium h-12 p-3';

  return (
    <>
      <label className="body mb-2" htmlFor={name}>
        {label}
      </label>
      <Field
        as={textArea ? 'textarea' : undefined}
        className={twMerge(fieldTwClassName, fieldClassName)}
        id={name}
        inputMode={inputMode}
        name={name}
        type={textArea ? undefined : type}
      />
    </>
  );
};

export default FormField;
